import { CheckUtils } from "../check-utils";
var DateConverter = /** @class */ (function () {
    function DateConverter() {
    }
    DateConverter.convertToDate = function (timestamp) {
        if (CheckUtils.isEmpty(timestamp))
            return null;
        return new Date(timestamp);
    };
    return DateConverter;
}());
export { DateConverter };
//# sourceMappingURL=date-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/date-converter.js
// module id = 404
// module chunks = 14